/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AlertingDataRequest,
    AlertingDataRequestFromJSON,
    AlertingDataRequestToJSON,
} from '../models/AlertingDataRequest';
import {
    type RollingAverageDataRequest,
    RollingAverageDataRequestFromJSON,
    RollingAverageDataRequestToJSON,
} from '../models/RollingAverageDataRequest';
import {
    type SensorDataRequest,
    SensorDataRequestFromJSON,
    SensorDataRequestToJSON,
} from '../models/SensorDataRequest';
import {
    type SensorDataRequestCreateRequest,
    SensorDataRequestCreateRequestFromJSON,
    SensorDataRequestCreateRequestToJSON,
} from '../models/SensorDataRequestCreateRequest';
import {
    type SensorDataRequestCreateResponse,
    SensorDataRequestCreateResponseFromJSON,
    SensorDataRequestCreateResponseToJSON,
} from '../models/SensorDataRequestCreateResponse';

export interface SensorDataAlertingRetrieveRequest {
    id: string;
}

export interface SensorDataCreateRequest {
    sensorDataRequestCreateRequest: SensorDataRequestCreateRequest;
}

export interface SensorDataRollingAveragesRetrieveRequest {
    id: string;
}

export interface SensorDataSensorRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class SensorDataApi extends runtime.BaseAPI {

    /**
     * Creates request options for sensorDataAlertingRetrieve without sending the request
     */
    async sensorDataAlertingRetrieveRequestOpts(requestParameters: SensorDataAlertingRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sensorDataAlertingRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/sensor-data/{id}/alerting`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the status and results of a sensor data request.
     */
    async sensorDataAlertingRetrieveRaw(requestParameters: SensorDataAlertingRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AlertingDataRequest>> {
        const requestOptions = await this.sensorDataAlertingRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AlertingDataRequestFromJSON(jsonValue));
    }

    /**
     * Get the status and results of a sensor data request.
     */
    async sensorDataAlertingRetrieve(requestParameters: SensorDataAlertingRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AlertingDataRequest> {
        const response = await this.sensorDataAlertingRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sensorDataCreate without sending the request
     */
    async sensorDataCreateRequestOpts(requestParameters: SensorDataCreateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['sensorDataRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'sensorDataRequestCreateRequest',
                'Required parameter "sensorDataRequestCreateRequest" was null or undefined when calling sensorDataCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/sensor-data`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SensorDataRequestCreateRequestToJSON(requestParameters['sensorDataRequestCreateRequest']),
        };
    }

    /**
     * Create a new sensor data request.
     */
    async sensorDataCreateRaw(requestParameters: SensorDataCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SensorDataRequestCreateResponse>> {
        const requestOptions = await this.sensorDataCreateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SensorDataRequestCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a new sensor data request.
     */
    async sensorDataCreate(requestParameters: SensorDataCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SensorDataRequestCreateResponse> {
        const response = await this.sensorDataCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sensorDataRollingAveragesRetrieve without sending the request
     */
    async sensorDataRollingAveragesRetrieveRequestOpts(requestParameters: SensorDataRollingAveragesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sensorDataRollingAveragesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/sensor-data/{id}/rolling-averages`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the status and results of a rolling average data request.
     */
    async sensorDataRollingAveragesRetrieveRaw(requestParameters: SensorDataRollingAveragesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RollingAverageDataRequest>> {
        const requestOptions = await this.sensorDataRollingAveragesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RollingAverageDataRequestFromJSON(jsonValue));
    }

    /**
     * Get the status and results of a rolling average data request.
     */
    async sensorDataRollingAveragesRetrieve(requestParameters: SensorDataRollingAveragesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RollingAverageDataRequest> {
        const response = await this.sensorDataRollingAveragesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sensorDataSensorRetrieve without sending the request
     */
    async sensorDataSensorRetrieveRequestOpts(requestParameters: SensorDataSensorRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling sensorDataSensorRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/sensor-data/{id}/sensor`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the status and results of a sensor data request.
     */
    async sensorDataSensorRetrieveRaw(requestParameters: SensorDataSensorRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SensorDataRequest>> {
        const requestOptions = await this.sensorDataSensorRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SensorDataRequestFromJSON(jsonValue));
    }

    /**
     * Get the status and results of a sensor data request.
     */
    async sensorDataSensorRetrieve(requestParameters: SensorDataSensorRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SensorDataRequest> {
        const response = await this.sensorDataSensorRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
